import React from 'react';
import Box from '../components/Box';

export const AboutThdjbr = () => {
  return (
    <Box style={{ backgroundColor: '#F8F8F8', border: "2px solid #96CCFF" }}>
      <ul className='pl3'>
          <li className='mb2'>You have to wait for Ethereum to commit your transaction as long as tens of seconds by spending costs, i.e. Ethereum.</li>
          <li className='mb2'>Note that we are using the Ethereum testnet of Sepolia, where PoW is used.   In contrast, the mainnet uses more effcient technologies.  Ethereum 2.0 could resolve this latency through PoS, Beacon chains, Sharding chains, and eWASM.</li>
      </ul>
    </Box>
  )
}

export default AboutThdjbr;
